import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useOverlayStore from "store/overlayStore";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useAddCategory = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const { setShowCreateCategory } = useOverlayStore();

	const history = useHistory();

	const save = async (obj) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(obj);

		const res = await instance.post("/categories", body);
		await queryClient.invalidateQueries("book_categories");
		return res;
	};

	return useMutation(save, {
		onSuccess: async ({ data: body }) => {
			setShowCreateCategory(false);
			toast.success("Book category created successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useAddCategory;
